import { Injectable, Compiler } from '@angular/core';
import { IPlatformService } from './iplatform.service';
import { TranslationService } from '../translation/translation.service';

@Injectable()
export class PlatformService implements IPlatformService {
  public _runtimeCompiler: Compiler;
  public _translationService: TranslationService;

  public constructor(runtimeCompiler: Compiler, translationService: TranslationService) {
    this._runtimeCompiler = runtimeCompiler;
    this._translationService = translationService;
  }

  public getPlatformWindow = (): Window => {
    return window;
  };
  public openPlatformWindow = (url: string): Window => {
    let win = window.open();
    if (win == null) {
      alert(this._translationService.getInstant('shared.platform.you-must-allow-popups-message'));
    } else {
      win.location.href = url;
    }

    return win;
  };

  public openPlatformWindowToDisplayHtml = (html: string): Window => {
    let win = window.open();
    if (win == null) {
      alert(this._translationService.getInstant('shared.platform.you-must-allow-popups-message'));
    } else {
      win.document.open();
      win.document.write(html);
      win.document.close();
    }

    return win;
  };
  public getPlatformGlobalVariable = (key: string): any => {
    let glovalValue: any = (<any>window)[key];
    return glovalValue;
  };

  public setPlatformGlobalVariable = (key: string, value: any): void => {
    (<any>window)[key] = value;
  };

  public clearPlatformCache = (): any => {
    //window.location.reload(true);

    //https://angular.io/docs/js/latest/api/core/index/Compiler-class.html#!#clearCache-anchor
    this._runtimeCompiler.clearCache();
  };
}
